<template>
  <div class="w-100 text-center my-2">
    <span>
      {{ placedCount }} de
      {{ totalCount }} palavras foram
      utilizadas no caça-palavras
    </span>
    <i
      :id="popoverId"
      class="fas fa-info-circle"
      style="cursor: pointer"
    />

    <d-popover
      :target="popoverId"
      placement="auto"
      :triggers="['hover']"
    >
      <template slot="title"> Palavras posicionadas </template>

      <template>
        <ul class="mb-0 pl-0 words" style="list-style-type: none">
          <li
            v-for="(item, index) in placedWordsList"
            :key="index + 'placed-word'"
          >
            ✅ {{ item }}
          </li>

          <li
            v-for="(item, index) in unplacedWordsList"
            :key="index + 'unplaced-word'"
          >
            ❌ {{ item }}
          </li>
        </ul>
      </template>
    </d-popover>
  </div>
</template>

<script>
import { getLength, getWordsStatus } from '_utils';

export default {
  name: 'GameStatusAndPopover',
  props: {
    gameSettings: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    popoverId() {
      return `popover-info-${this.index + 1}`;
    },
    placedCount() {
      return this.gameSettings.placedWords.length;
    },
    totalCount() {
      return getLength(this.gameSettings.wordsList);
    },
    wordsStatus() {
      return getWordsStatus(
        this.gameSettings.wordsList,
        this.gameSettings.placedWords,
      );
    },
    placedWordsList() {
      return this.wordsStatus.placed;
    },
    unplacedWordsList() {
      return this.wordsStatus.unplaced;
    },
  },
};
</script>

<style lang="scss" scoped>
.words {
  font-size: 14px;
}
</style>
